import { handleOfficeError } from '@utils-global';
import {
  EwsResponseError,
  getEWSRequestBodyTemplate,
  getMoveMailBodyTemplate,
  isEwsResponseFault,
  parseResponse,
  parseResponseAttribute,
  parseXml,
  withEwsRetry,
  type EwsActionResult,
} from './helpers';

/** DistinguishedFolderId, culture-invariant on every mailbox. */
const JUNK_FOLDER_ID = 'junkemail';

const OPERATION = 'EWS move to spam';

export const moveMailToSpam = (
  mailId: string,
  isSharedMailbox: boolean = false,
): Promise<EwsActionResult> =>
  withEwsRetry(
    () =>
      new Promise<EwsActionResult>((resolve, reject) => {
        const requestBody = getEWSRequestBodyTemplate(
          getMoveMailBodyTemplate(JUNK_FOLDER_ID, mailId),
        );
        Office.context.mailbox.makeEwsRequestAsync(requestBody, (result) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
            reject(handleOfficeError(result.error, { operation: OPERATION, isSharedMailbox }));
            return;
          }

          const doc = parseXml(result.value);
          const [responseCode, messageText] = parseResponse(doc, ['ResponseCode', 'MessageText']);

          if (isEwsResponseFault(responseCode)) {
            reject(
              new EwsResponseError(
                OPERATION,
                responseCode,
                messageText ?? undefined,
                JUNK_FOLDER_ID,
              ),
            );
            return;
          }

          resolve({
            movedMailId: parseResponseAttribute(doc, 'ItemId', 'Id'),
          });
        });
      }),
  );
